import React from 'react';
import './hb-money.scss';
import {
  getPGCustomerId,
  validateUPI,
} from 'hb-redux-store/feature/checkout/checkout.action';
import { connect } from 'react-redux';
import SecondaryNav from 'components/mweb/SecondaryNav/SecondaryNav';
import Cards from 'components/mweb/Payments/Cards';
import Upis from 'components/mweb/Payments/Upis';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import Wallets from 'components/mweb/Payments/Wallets';
import NetBanks from 'components/mweb/Payments/NetBanks';
import COD from '../../checkout/COD';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { setCartQtyCount } from 'hb-redux-store/feature/cart/cart.action';
import history from 'hb-redux-store/history';
import {
  CHECKOUT_FAILURE_REDIRECT,
  SOURCE,
} from 'hb-redux-store/util/constantServices';
import {
  setPaymentFailModal,
  showOrderFailedModal,
} from 'hb-redux-store/feature/modal/modal.action';
import RazorpayService from 'hb-redux-store/util/RazorpayService';
import Button from 'components/common/Button/Button';
import Modal from 'components/mweb/Modal/Modal';
import { queryStringToJSON } from 'hb-redux-store/util/miscellaneousServices';
import {
  postRechargeWallet,
  getRechargeMethods,
} from 'hb-redux-store/feature/wallet/wallet.action';
import {
  checkoutPrefix,
  getCheckoutRoute,
} from '../../checkout/checkout.routes';
import PaymentHeader from '../../checkout/PaymentHeader';
import { MEMBERSHIP_PAYMENT_ERROR_MESSAGE } from 'hb-redux-store/constants/halalboxPrime';
import { HB_PRIME_ROUTE } from 'components/web-feature/Home/constant';

class HBMoneyRecharge extends React.Component {
  constructor(props) {
    super(props);
    this.isRechargeForOrder =
      props?.match?.path === `/${checkoutPrefix}/vxl-money/recharge`;
    this.state = {
      selectedMode: null,
      razorPayInstance: null,
      paymentInProgress: false,
      showPopupBlockedModal: false,
      razorpayDetails: null,
      source: this.isRechargeForOrder ? SOURCE.RECHARGE_FOR_ORDER : '',
    };
  }

  paymentInProgress = false;
  PAYMENT_MODES = [
    { key: 'savedCards', title: 'Credit/Debit Cards', component: Cards },
    { key: 'savedUPIs', title: 'UPI', component: Upis },
    { key: 'wallets', title: 'Wallets', component: Wallets },
    { key: 'netBankings', title: 'Net banking', component: NetBanks },
    { key: 'pod', title: 'Pay On Delivery', component: COD },
  ];
  componentDidMount() {
    this.props.getRechargeMethods();
    const qs = this.props.location.search;
    const { result, reason } = queryStringToJSON(qs);
    if (result === 'failed' && reason) {
      this.props.setPaymentFailModal({ reason, visible: true });
    }
    RazorpayService.initRazorpay();
  }
  showPgInfoPopup = razorpayDetails => {
    this.setState({ razorpayDetails, showPopupBlockedModal: true });
  };
  openRazorpay = () => {
    const { razorPayErrorCb } = this.state.razorpayDetails;
    RazorpayService.makePayment({
      ...this.state.razorpayDetails,
      razorPayErrorCb: () => {
        this.setState(
          {
            razorpayDetails: null,
            showPopupBlockedModal: false,
          },
          () => {
            razorPayErrorCb();
          }
        );
      },
    });
  };

  onPlaceOrder = details => {
    if (this.paymentInProgress || this.state.paymentInProgress) return;
    RazorpayService.initRazorpay();
    this.paymentInProgress = true;
    this.setState({ paymentInProgress: true }, () => {
      const payload = {
        ...details,
        amount: this.props.rechargeMethods.rechargeWalletAmount,
        pgCid: this.props.pgCid,
        pgId: this.props.rechargeMethods.pgId,
        isRechargeForOrder: this.isRechargeForOrder,
        source: this.state.source,
        successCb: ({ tnxNo = '', orderNo = '' }) => {
          this.paymentInProgress = false;
          let redirectUrl = `/my/vxl-money?result=success&reason=${tnxNo}`;
          if (this.isRechargeForOrder && orderNo) {
            this.props.setCartQtyCount(0);
            redirectUrl = `/co/order/${orderNo}`;
          }
          history.push(redirectUrl);
        },
        failCb: error => {
          this.setState({ paymentInProgress: false }, () => {
            this.paymentInProgress = false;
            if (error?.step) {
              const redirect =
                error.error?.data?.redirect || error.redirect || null;
              if (redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.CART) {
                this.props.setAppNotification(
                  'Your cart has changed. You will be shortly redirected to cart'
                );
                return setTimeout(() => history.push('/cart'), 2000);
              } else if (
                redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.SHIPMENT
              ) {
                this.props.setAppNotification(
                  'Error with delivery slots. You will be shortly redirected to choose slot.'
                );
                return setTimeout(
                  () => history.push(getCheckoutRoute('shipment')),
                  2000
                );
              } else if (
                redirect?.toLowerCase() ===
                CHECKOUT_FAILURE_REDIRECT.ORDER_FAILURE
              ) {
                this.props.showOrderFailedModal(true);
                history.push('/cart');
              } else if (
                redirect?.toLowerCase() ===
                CHECKOUT_FAILURE_REDIRECT.PG_NOT_LOADED
              ) {
                this.props.setAppNotification(
                  'Error loading Payment Gateway. Refresh and try again.'
                );
              } else if (
                redirect === CHECKOUT_FAILURE_REDIRECT.SHOW_PG_INFO_POPUP
              ) {
                this.showPgInfoPopup(error.pgDetails);
              } else if (
                redirect === CHECKOUT_FAILURE_REDIRECT.MEMBERSHIP_LANDING_SCREEN
              ) {
                this.props.setAppNotification(MEMBERSHIP_PAYMENT_ERROR_MESSAGE);
                history.push(HB_PRIME_ROUTE);
              }
            } else {
              this.props.setAppNotification(
                error?.errorMessage ||
                  'Fail to process payment. Please try again.'
              );
            }
          });
        },
      };
      this.props.postRechargeWallet(payload);
    });
  };

  onPaymentModeChange = newMode => {
    this.setState({ selectedMode: newMode });
  };
  render() {
    const { rechargeMethods } = this.props;
    return (
      <div className="payments">
        {/*<SecondaryNav*/}
        {/*  showSearch={false}*/}
        {/*  showCart={false}*/}
        {/*  title="Select Payment Methods"*/}
        {/*  capitalize*/}
        {/*/>*/}
        <PaymentHeader
          source="RECHARGE_PAYMENT"
          summary={{ rechargeAmount: rechargeMethods?.rechargeWalletAmount }}
        />
        {!rechargeMethods && <Loader />}
        {rechargeMethods && (
          <React.Fragment>
            {/*<div className="payments--summary">*/}
            {/*  <div className="payments--summary--payable justify-content--space-between">*/}
            {/*    <div className="">Recharge Amount</div>*/}
            {/*    <div className="">*/}
            {/*      &#8377;{rechargeMethods.rechargeWalletAmount}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="payments--payment-modes">
              {this.PAYMENT_MODES.map(mode => {
                // if (!paymentMethods[mode.key]) return null;
                const podProps = {};
                if (mode.key === 'pod') {
                  podProps.isCodEnable = rechargeMethods.isCOD;
                  podProps.codMessage = rechargeMethods.isCODMessage;
                  podProps.isPodEnable = rechargeMethods.isPOD;
                  podProps.podMessage = rechargeMethods.isPODMessage;
                }
                return (
                  <mode.component
                    title={mode.title}
                    details={rechargeMethods[mode.key]}
                    selectedMode={this.state.selectedMode}
                    onPaymentModeChange={this.onPaymentModeChange}
                    onPlaceOrder={this.onPlaceOrder}
                    validateUPI={this.props.validateUPI}
                    key={mode.key}
                    code={mode.key}
                    pgId={rechargeMethods.pgId}
                    ctaText={
                      this.isRechargeForOrder ? 'Place Order' : 'Recharge'
                    }
                    {...podProps}
                  />
                );
              })}
            </div>
          </React.Fragment>
        )}
        <Modal
          visible={this.state.showPopupBlockedModal}
          onCancel={() => this.setState({ showPopupBlockedModal: false })}
          closable={false}
          maskClosable={false}
          wrapClassName="pg-modal-failed"
        >
          <div className="pg-modal-failed--content">
            Proceed to payment
            <br />
          </div>
          <div className="pg-modal-failed--cta">
            <Button
              className="button button-primary full-width"
              onClick={this.openRazorpay}
            >
              Pay Now
            </Button>
          </div>
        </Modal>
        {this.state.paymentInProgress && (
          <div className="payments--oip">
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ walletReducer, modalReducer }) => ({
  rechargeMethods: walletReducer.rechargeMethods,
  pgCid: walletReducer.pgCid,
  orderFailedModal: modalReducer.orderFailedModal,
});

const mapDispatchToProps = {
  getRechargeMethods,
  getPGCustomerId,
  postRechargeWallet,
  setAppNotification,
  validateUPI,
  setCartQtyCount,
  showOrderFailedModal,
  setPaymentFailModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(HBMoneyRecharge);
